import React from 'react';

import Header from '../partials/Header';
import ResearchFeatures from '../partials/ResearchFeatures';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function Research() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">

        {/*  Page sections */}
        <ResearchFeatures />
        <Cta />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default Research;